import { render } from "./EditTeamDialog.vue?vue&type=template&id=213d4ab6&scoped=true"
import script from "./EditTeamDialog.vue?vue&type=script&lang=js"
export * from "./EditTeamDialog.vue?vue&type=script&lang=js"

import "./EditTeamDialog.vue?vue&type=style&index=0&id=213d4ab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213d4ab6"]])

export default __exports__